import pl from './pl'
import Utils from '../Utils'

var plMsg = {
  'agreements.title': 'Umowy',
  'agreements.error.mandatory': "Akceptacja jest warunkiem dalszego korzystania z usług firmy Deeper.",
  'agreements.error.blank': "Wybierz opcję",
  'agreements.back': 'Wstecz',
  'agreements.agree': 'Zaakceptuj',
  'agreements.decline': 'Odrzuć',
  'agreements.text.full': 'Pełny tekst umowy'
}

Utils.addTerms(plMsg, pl)

export default plMsg



// WEBPACK FOOTER //
// ./src/lang/plMsg.js